/** Survives the full-page redirect to /home so the success snackbar can show after reload. */
export const CLINIC_CHANGE_FLASH_MESSAGE_STORAGE_KEY = 'clinicChangeSuccessMessage';

export interface ClinicChangeFlashMessage {
  /** Final localized message text (translated before redirect). */
  message: string;
}
